<unh-generic-content-container class="md-column xl-column lg-column align-center title-container">
    <unh-section-title
          [itemTitle]="sectionTitle"
          [itemSubtitle]="sectionSubtitle"
        ></unh-section-title>
</unh-generic-content-container>

 <div class="benefits-grid">
    <unh-generic-content-container class="md-column align-center benefits-card" *ngFor="let item of items">
        <unh-slot-left>
            <img [src]="item.iconUrl" alt="">
        </unh-slot-left>
        <unh-slot-middle>
            <h3 class="title">{{item.title}}</h3>
        </unh-slot-middle>
        <unh-slot-right>
           <p class="subtitle">{{item.subtitle}}</p>
        </unh-slot-right>
    </unh-generic-content-container>
</div>
